import { usePartnerPageMeta } from "@/components/partner/PartnerWorkspaceShell";
import { PartnerGoogleCalendarCard } from "@/components/partner/PartnerGoogleCalendarCard";

/*
 * Resend email + outbound webhooks UI temporarily disabled.
 * Backend edge function partner-integrations remains deployed but is not invoked.
 * Re-enable: restore previous Integrations UI + uncomment dispatch in usePartnerData.
 */

const PartnerIntegrations = () => {
  usePartnerPageMeta({
    title: "Integrations",
    subtitle: "Google Calendar and Meet",
  });

  return (
    <div className="space-y-6 max-w-3xl">
      <PartnerGoogleCalendarCard />

      {/*
      === Resend email + Outbound webhooks (paused) ===
      */}
    </div>
  );
};

export default PartnerIntegrations;
